/* eslint-disable react/react-in-jsx-scope */

import {
  AccountsIcon,
  CalendarIcon,
  HistoryIcon,
  RepsIcon,
} from "components/common/ClinicHeader";
import { ICONS } from "components/common/constants/swal.constants";
import GenericModal from "components/common/GenericModal";
import NavHeader from "components/common/NavHeader";
import useLogout from "components/common/useLogout";
import { useState } from "react";
import { Calendar, Users, History, LogOut, Building, MessageSquare } from "lucide-react";
import NewNavLink from "components/common/NewNavLink";
const links = [
  {
    pathname: "/impersonation-options",
    Img: AccountsIcon,
    name: "Offices",
    descriptor: "Manage your Offices",
    icon: Building,
  },
  {
    pathname: "/delegate/calendar",
    Img: CalendarIcon,
    name: "QuickView",
    descriptor: "View Appointments",
    icon: Calendar,
  },
  {
    pathname: "/delegate/reps",
    Img: RepsIcon,
    name: "Reps",
    descriptor: "Manage Representatives",
    icon: Users,
  },
  {
    pathname: "/delegate/user-activity",
    Img: HistoryIcon,
    name: "Activity Logs",
    descriptor: "User Activity Log",
    icon: History,
  },
  {
    pathname: "/delegate/chat",
    Img: MessageSquare,
    name: "Chat",
    descriptor: "Conversations",
    icon: MessageSquare,
  },
];

const Header = () => {
  const [genericModalData, setGenericModalData] = useState({
    show: false,
  });
  const showLogoutSuccess = () => {
    setGenericModalData({
      show: true,
      title: "Goodbye",
      subtext: "See you next time!",
      icon: ICONS.checkMark,
    });
  };
  const showLogoutError = () => {
    setGenericModalData({
      show: true,
      title: "Oops!",
      subtext: "Some error occurred",
      icon: ICONS.error,
    });
  };
  const hideModal = () => {
    setGenericModalData((prevState) => ({ ...prevState, show: false }));
  };

  const logOut = useLogout(
    "/login",
    showLogoutSuccess,
    showLogoutError,
    hideModal,
  );

  return (
    <>
      {genericModalData.show && (
        <GenericModal
          show={genericModalData.show}
          onHide={hideModal}
          title={genericModalData?.title || ""}
          subtext={genericModalData?.subtext || ""}
          icon={genericModalData?.icon || undefined}
          hideBtn
        />
      )}
      <NavHeader
        links={links}
        renderLinks={(fromSidebar) => {
          return (
            <>
              <NewNavLink
                onClick={() => {
                  return logOut();
                }}
                fromSidebar={fromSidebar}
                item={{
                  pathname: "/login",
                  name: "Logout",
                  descriptor: "Sign Out",
                  icon: LogOut,
                }}
              />
            </>
          );
        }}
      />
    </>
  );
};

export default Header;
